import styled from "styled-components";
import { StyledTabsWrapper } from "../styles/styledTabs";
import { StyledInputBlock } from "../styles/styledTabsForm";

export const StyledPayoutWrapper = styled.div`
  .payouts-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 1fr;
    grid-gap: 25px;
    &__left {
      display: grid;
      align-items: center;
      grid-template-columns: repeat(2, max-content) 175px;
      grid-template-rows: 1fr;
      grid-gap: 20px;
      @media screen and (max-width: 576px) {
        grid-template-columns: 175px max-content;
      }
    }
    @media screen and (max-width: 992px) {
      grid-template-columns: repeat(2, max-content);
      grid-gap: 20px;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
    
    &__create-invoice {
      display: inline-grid;
      align-items: center;
      justify-content:  end;
      @media screen and (max-width: 992px) {
        justify-content:  start;
      }
    }
  }
  .payout-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }
  .payout-table {
    &__head, &__row {
      grid-template-columns: repeat(2, minmax(210px, .85fr)) repeat(9, minmax(150px, 1fr)) repeat(2, minmax(150px, 1fr)) minmax(210px, .85fr) 220px;
    }
    .note {
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }
      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      &__note {
        max-width: 100%;
        white-space: inherit;
        overflow: inherit;
        grid-column-start: 1;
        grid-column-end: 3;
      }
      .icon-light-info {
        display: none;
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
      &__note {
        grid-column-end: 1;
      }
    }
  }
`;

export const StyledPayoutDetailsWrapper = styled.div`
  .payout-details-head {
    padding: 15px 0 25px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    
    .icon-light-reload {
      padding-right: 10px;
      font-weight: 700;
    }
    
    a, button {
      height: 45px;
    }
    
    ${StyledInputBlock} {
      width: initial;
    }

    &__alert {
      align-items: center;
    }
  }

  .refiling-details-head {
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 576px) {
      flex-direction: column;
    }
  }
`;

export const StyledPayoutDetailsTabsWrapper = styled(StyledTabsWrapper)`
  min-height: calc(100vh - 150px - 150px);
  padding: 0;
  border: none;
  box-shadow: none;
  @media screen and (max-width: 992px) {
    .tab-head, .tab-body {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
    .tab-head {
      margin-bottom: 15px;
      border-bottom: 1px solid ${({theme}) => theme.surface.border};
    }
  }
`;

export const StyledPayoutDetailsContent = styled.div`
  ${({ mt }) => mt && `margin-top: ${mt}px`};
  .payout-details-content {
    &__block {
      grid-template-columns: 20% 80%;
    }
    &__head {
      padding: 0 25px 20px;
    }
    &__row {
      grid-template-columns: repeat(2, 50%);
      & > div {
        padding: 0;
        margin: 0;
        &:before {
          display: none;
        }
        &:last-child {
          display: inline-flex;
          p {
            width: 100%;
            text-align: left;
            overflow-wrap: break-word;
          }
        }
      }
    }
    .errors {
      color: ${({theme}) => theme.state.error};
    }
    .icon-light-copy {
      cursor: pointer;
    }
    .service {
      display: grid !important;
      grid-template-columns: 100%;
      grid-template-rows: max-content 55px;
      grid-gap: 10px;
      &__icon {
        border: 1px solid ${({theme}) => theme.surface.border};
        background-color: ${({theme}) => theme.surface.background};
        border-radius: 5px;
        margin: 0;
        width: 65px;
        height: 55px;
        grid-area: inherit;
      }
    }
    
    @media screen and (max-width: 1920px) {
      max-width:  inherit;
    }
    @media screen and (max-width: 992px) {
      &__block {
        grid-template-columns: 100%;
      }
    }
    @media screen and (max-width: 576px) {
      &__row {
        padding: 15px 0;
        grid-template-columns: 100%;
        & > div:first-child {
          padding-bottom: 10px;
          color: ${({theme}) => theme.text.primary};
          font-weight: 600;
        }
      }
    }
  }
`;

export const StyledPayoutDetailsLogs = styled.div`
  .logs-head {
    padding: 5px 0 25px;
  }

  .logs-table {
    &__head-system, &__row-system {
      grid-template-columns: 150px 300px 150px minmax(250px, 1fr) 100px 200px;
    }
    &__head-service, &__row-service {
      grid-template-columns: 170px repeat(2, minmax(250px, .85fr)) 150px minmax(250px, 1fr) 100px 200px;
    }
    &__event {
      position: relative;
    }
    .read-more {
      padding: 3px 7px;
      border-radius: 25px;
      color: ${({theme}) => theme.text.inverse};
      font-size: 12px;
      font-weight: 600;
      display: none;
      background-color: ${({theme}) => theme.brand.primary};
      border: none;
      outline: none;
      position: absolute;
      bottom: 0;
      right: 5px;
    }
    .read-more_is-overflow {
      display: block;
    }
    .read-more_active {
      bottom: -23px;
    }

    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head-system,
      &__head-service {
        display: none;
      }
      &__row-system,
      &__row-service {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }

      &__event {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }

    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
      &__event {
        grid-column-end: 1;
      }
    }
  }
`;